<div class="product-info">

  <ng-container *ngIf="!viewSlider">
    <div class="left-block">
      <ng-container *ngTemplateOutlet="imageBlock"></ng-container>
      <ng-container *ngTemplateOutlet="sectionInfo"></ng-container>
    </div>

    <div class="right-block">
      <ng-container *ngTemplateOutlet="nameBlock"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="viewSlider">
    <ng-container *ngTemplateOutlet="sliderBlock"></ng-container>
    <ng-container *ngTemplateOutlet=" nameBlock "></ng-container>
    <ng-container *ngTemplateOutlet="sectionInfo"></ng-container>
  </ng-container>

</div>


<ng-template #sliderBlock>
  <div *ngIf="product.id" class="">
    <ng-container #testBlock *ngIf="allImages.length > 0">
      <div class="slider-container">
        <div class="image-slider">
          <slider [slidesArray]="allImages" [shadow]="true" [timeOut]="250"></slider>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #imageBlock>
  <div class="main-image-section" *ngIf="product.id" >
    <div class="main-image">
      <image [imageLink]="product.mainPhoto" [style]="imageShadowStyle" *ngIf="product.mainPhoto" [alt]="product.author + ' ' + product.name"></image>
      <img  src="../assets/not_found.png" *ngIf="!product.mainPhoto && !product.imageLink" class="image-not-found"/>
      <img  src="{{product.imageLink}}" *ngIf="!product.mainPhoto && product.imageLink" class="image-from-link"  alt="{{product.author}} {{product.name}}"/>


    </div>
  </div>

  <div *ngFor="let im of product.photos" class="product-photos">
    <image [imageLink]="im.photo" [style]="imageShadowStyle" class="image-list-photos" [alt]="product.author + ' ' + product.name"></image>
  </div>
</ng-template>

<ng-template #sectionInfo>

  <div class="section-info" *ngIf="product">

    <div class="tech-info">
      <div *ngIf="product.isbn">
        <span>ISBN: </span>
        <span>{{product.isbn}}</span>
      </div>
      <div *ngIf="product.pageAmount">
        <span>Количество страниц: </span>
        <span>{{product.pageAmount}}</span>
      </div>
      <div *ngIf="product.format">
        <span>Формат: </span>
        <span>{{product.format.format}}</span>
      </div>
      <div *ngIf="product.illustrator">
        <span>Иллюстратор: </span>
        <span>{{product.illustrator}}</span>
      </div>
      <div *ngIf="product.ageCategory">
        <span>Возраст: </span>
        <span>{{product.ageCategory.ageCategory}}</span>
      </div>
      <div *ngIf="product.year">
        <span>Год: </span>
        <span>{{product.year}}</span>
      </div>
      <div *ngIf="product.coverType">
        <span>Тип обложки: </span>
        <span>{{coverTypes[product.coverType.type]}}</span>
      </div>
      <div *ngIf="product.weight > 0 ">
        <span>Вес: </span>
        <span>{{product.weight}} г.</span>
      </div>
    </div>

    <div class="description" [innerHTML] = "getSanitize(product.description)">
    </div>

  </div>
</ng-template>
<ng-template #nameBlock>
  <div class="about"  *ngIf="product.id">
    <div *ngIf="product.availability.status == 'ended'" class="status ended">Закончилось</div>
    <div class="author">{{product.author}}</div>
    <h1 class="product-name">{{product.name}}</h1>

    <div class="short-description" *ngIf="product.shortDescription" [innerHTML] = "getSanitize(product.shortDescription)"></div>
    <div class="price">

      <span *ngIf="product.discount" class="discount"> {{product.retailPriceEuro + ' \u20AC'}}</span>
      {{product.discountPriceEuro + ' \u20AC'}}
    </div>
    <button mat-button class="main-button to-cart"
            (click)="addToCart()"
            [disabled]="countInCart >= product.countInStock && product.countInStock > 0  || (product.availability.status != 'in_stock' &&  product.availability.status != 'available_to_order')"
    >В корзину
    </button>

  </div>
</ng-template>

